<template>
<section class="main">
  <ol-map ref="ol-map" :zoom="17"></ol-map>
</section>
</template>

<script>
/* eslint-disable */
import OlMap from './OlMap'
export default {
  name: 'Cartographie',
  components: {
    OlMap
  },
  data() {
    return {}
  },
  created() {
    document.body.classList.add('map')
    document.body.scrollIntoView({
      behavior: 'smooth'
    })
  },
  mounted() {
    document.body.classList.add('hamburger_menu')
  },
  destroyed() {
    document.body.classList.remove('hamburger_menu')
    document.body.classList.remove('map')
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main>>>form {
  background-color: white;
}

.main>>>.v-autocomplete {
  position: initial;
}

/*
.single_page >>> input {
  height: 38px;
}*/
.main>>>div.search-btn {
  width: 50px;
  height: 38px;
  /* background-color: #007abc; */
  background-image: url(../../assets/img/icon-search.svg);
  background-size: 23px;
  background-position: center;
}

.main>>>div.search-btn:hover {
  background-color: #282828;
  -webkit-transition: background-color .5s linear;
  -o-transition: background-color .5s linear;
  transition: background-color .5s linear;
}
</style>
